import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { capitalizer } from '../../../../utils';
import { INITIAL_PAGES_LIST } from '../constants';
import locale from "../../../../locale";
import { usePagesContext } from '../context/PagesContext';
import PagesListTable from '../components/PagesListTable';
import { Col, DropdownButton, MenuItem, Row } from 'react-bootstrap';

const PagesList = ({ event }) => {
    const { pages, handleAddPage } = usePagesContext();

    const pagesOptions = useMemo(() => {
        const optional = {
            shop: event.moduleShop?.enabled
        };
        return INITIAL_PAGES_LIST.filter(page => !(page in optional) || optional[page]).filter(page => !pages.find(({type}) => page === type));
    }, [event, INITIAL_PAGES_LIST, pages])

    return (
        <section>
            <Row>
                <Col xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <DropdownButton
                            id="pages_dropdown"
                            bsStyle="default"
                            title={locale('pages.addPage')}
                            disabled={!pagesOptions.length}
                        >
                            {
                                pagesOptions.map((page) => (
                                    <MenuItem
                                        key={page}
                                        eventKey={page}
                                        onSelect={() => handleAddPage(page)}
                                    >
                                        {locale(`pages.${page}`)}
                                    </MenuItem>
                                ))
                            }
                        </DropdownButton>
                    </div>
                </Col>
            </Row>
            <br />
            <Row>
                <Col xs={12}>
                    <PagesListTable event={event} />
                </Col>
            </Row>
            <br />
        </section>
    )
}


const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(PagesList);
